module.exports = __webpack_public_path__ + "static/media/buy_donate_important.8871169f.svg";